export default function ImageBand({ src, alt, height = "h-48 lg:h-64" }) {
  return (
    <div className={`w-full ${height} overflow-hidden relative`} data-testid="image-band">
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-[#1D3557]/20" />
      <div className="absolute inset-0 bg-white/75" />
    </div>
  );
}
